import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { ConfigProvider, App as AntdApp } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import i18n from "./i18n";

dayjs.locale("zh-cn");

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: "#0d9488", // teal-600 匹配项目中使用的交互色
            borderRadius: 8,
          },
        }}
      >
        <AntdApp>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </AntdApp>
      </ConfigProvider>
    </I18nextProvider>
  );
}

export default App;
